import PaintProspectingWorkspace from '../../placeholders/PaintProspectingWorkspace';

export default PaintProspectingWorkspace;
